import { FormFormattableTextParseResult } from "@itk/mui-components";
import numeral from "numeral";

const phoneReplaceRegex = /(\d{2})(?!( )|$)/g;

export const formatPhoneNumber = (value: string | null) => {
  return value?.replace(phoneReplaceRegex, "$1 ") ?? "";
};

export const formatCivilRegistrationShowDigits = (value: string | null) => {
  return value?.replace(/^(\d{6})-?(\d{1,4}).*/g, "$1-$2") ?? "";
};
export const formatCivilRegistrationHideDigits = (value: string | null) => {
  return value?.replace(/^(\d{6}).*$/g, "$1-####") ?? "";
};

export const parseCivilRegistration = (value: string): FormFormattableTextParseResult<string> => {
  if (!/^[\d-]*$/.test(value)) return { preventDefault: true };

  return { value: value.replaceAll("-", "") };
};

export const formatNumber = (value: number, numberOfDecimals = 2, useThousandSeparator = true): string => {
  const formatString = useThousandSeparator ? `0,0.${"0".repeat(numberOfDecimals)}` : `0.${"0".repeat(numberOfDecimals)}`;
  return numeral(value).format(formatString);
};

export const formatDuration = (value: number, numberOfDecimals = 2): string => {
  return formatNumber(value, numberOfDecimals, false);
};

export const truncateString = (comment: string, maxLength: number): string => {
  if (comment.length > maxLength) {
    return comment.substring(0, maxLength) + "...";
  }
  return comment;
};
